// extracted by mini-css-extract-plugin
export default {"root":"TableTools__root___KJ7dE","switcher":"TableTools__switcher___96OrJ","switcherHint":"TableTools__switcherHint___OGQNr"};